<mat-dialog-content class="mat-typography">
	<div [innerHTML]="message"></div>
</mat-dialog-content>
<br>
<mat-dialog-actions align="end">
	<button class="cancel-popup" mat-stroked-button (click)="cancel()">Close</button>
</mat-dialog-actions>
